import '../../App.css'
import CodeBlock from "../../CodeBlock.js"
import { Link } from "react-router-dom"



export default function RegisterMissionAppTutorial() {

  return (
    <>
      <div className="leftText">
        <h1><a href="https://kubos-preservation-group.github.io/kubos/tutorials/app-register.html" target="_blank" rel="noreferrer">Registering a Mission Application</a></h1>
        <h3 className="lastUpdate">Last updated September 11th, 2025</h3>

      </div>
    </>
  );
}